import { useAddUnit } from "../hooks/UnitHooks";
import { UnitDTO } from "../types/unitDTO";
import ValidationSummary from "../ValidationSummary";
import UnitForm from "./UnitForm";
import { toast } from 'react-toastify';
import { ClipLoader } from "react-spinners";
import { useTranslation } from 'react-i18next';
import { useParams } from "react-router-dom";
import { useState } from "react";

const UnitAdd = () => {
  const { t } = useTranslation();
  const createValidToDate = () => {
    const date = new Date();
    date.setFullYear(2099);
    date.setSeconds(0, 0);
    return date;
  };
  const { organisationId } = useParams<{ organisationId: string }>();
  if (!organisationId) throw new Error("Missing organisationId from params");
  const [unit, setUnit] = useState<UnitDTO>({
    id: "00000000-0000-0000-0000-000000000000",
    organisationId: organisationId,
    name: "",
    validFrom: new Date(new Date().setSeconds(0, 0)),
    validTo: createValidToDate(),
    lastModified: new Date(),
    strength: {
      platoonLeaderCount: 0,
      sectionLeaderCount: 0,
      crewCount: 0,
    },
    station: {
      id: "",
      organisationId: organisationId,
      address: "",
      name: "",
      municipality: "",
      validFrom: new Date(new Date().setSeconds(0, 0)),
      validTo: createValidToDate(),
      lastModified: new Date(),
      },
      priority: 0
  });
  const addUnitMutation = useAddUnit(organisationId, setUnit);

  return (
    <>
      {addUnitMutation.isError && (
        <ValidationSummary error={addUnitMutation.error} />
      )}
      {addUnitMutation.isPending ? (
        <div className="spinner-container" style={{ textAlign: 'center', marginTop: '20px' }}>
          <ClipLoader size={50} color={"#123abc"} loading={true} />
          <p>{t('unit.addWait')}</p>
        </div>
      ) : (
        <UnitForm
          headerText={t('unit.add')}
          dataToEdit={unit}
          submitted={(unit) => addUnitMutation.mutate(unit, {
            onSuccess: () => {
              toast.success(t('unit.addSuccess'));
              history.back();
            },
            onError: () => {
              toast.error(t('unit.addError'));
            }
          })}
        />
      )}
    </>
  );
};

export default UnitAdd;
